import React, { Component} from 'react';
import $ from 'jquery';





class EMailAddressModal extends Component {

   

    render() {       
        
        return (
            <div>
                <div className="modal fade " id="eMailAddressModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="eMailAddressModalLabel" aria-hidden="true">
                    <div className="modal-dialog" >
                        <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-target="#pdfViewer" data-toggle="modal" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                            <div className="modal-body" style={{paddingLeft: 0, paddingRight:0, paddingBottom:0}}>
                                 
                               
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        );
    }
}

export default EMailAddressModal;